import { useEffect } from "react";

/** Tiny redirect to the standalone Socios Fundadores HTML deck. */
const SociosFundadoresRedirect = () => {
  useEffect(() => {
    window.location.replace("/sociosfundadores.html");
  }, []);
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0D1B2A",
      color: "#c9a227",
      fontFamily: "system-ui, sans-serif",
      fontSize: "14px",
      letterSpacing: "2px",
      textTransform: "uppercase",
    }}>
      Cargando…
    </div>
  );
};

export default SociosFundadoresRedirect;
